<template>
    <div>
        <el-select
            v-model="cec_id"
            placeholder="互联互通公司"
            clearable
            filterable
            @change="chooseCec"
            :style="{ width }"
            default-first-option
            no-data-text="未加载出数据，请尝试刷新重试"
        >
            <el-option
                v-for="item in cecInfo"
                :key="item.id"
                :label="item.value"
                :value="item.id"
            ></el-option>
        </el-select>
    </div>
</template>
<script>
import store from "@/store";
import { mapState } from "vuex";
export default {
    data() {
        return {
            cec_id: null,
            cecInfo: null,
        };
    },
    props: {
        width: String,
        cecId: null,
    },
    computed: {
        ...mapState(["contactInfo"]),
    },
    watch: {
        cecId: {
            handler(val) {
                this.cec_id = val;
            },
            deep: true,
        },
    },
    created() {
        this.getCecData();
    },
    methods: {
        /*获取互联互通站点信息*/
        async getCecData() {
            await store.dispatch("getConnact", {});
            let getData = [];
            for (let i = 0; i < this.contactInfo.length; i++) {
                getData[i] = {
                    id: this.contactInfo[i].id,
                    value: this.contactInfo[i].name,
                };
            }
            this.cecInfo = JSON.parse(JSON.stringify(getData));
        },
        chooseCec(cecId) {
            this.$emit("chooseCec", cecId);
        },
    },
};
</script>
